import React, { useState, useEffect } from 'react';
import CustomInput from '../../../Utility/Components/CustomInput';
import Utility from '../../../Utility/Utility';
import { loaderStateTrue, loaderStateFalse } from '../../../Actions/AllAction';
import { setToken, logOutApp } from '../Actions/LoginAction';
import { connect } from 'react-redux';
import * as LoginController from '../Controller/LoginController'
import '../Assets/css/logindoc.scss';
import '../Assets/css/loginresponsivedoc.scss';
import { withNamespaces } from 'react-i18next';
import ValidateUtility from '../../../Utility/ValidateUtility';
import { useParams } from 'react-router-dom';
import ModalGlobal from '../../../Utility/Components/ModalGlobal';
import SmsVerification from '../Components/SmsVerification';
import { getRedirectInfo, createRedirectUrl, clearRedirectInfo } from "../../../Utility/helpers/authRedirect";

const ForgotPassword = (props) => {
    const { type } = useParams();
    const [username, setusername] = useState("")
    const [phone_number, setphone_number] = useState("")
    const [smsVerficationPopupStatus, setSmsVerficationPopupStatus] = useState("")
    const [smsVerificationModalContentFlag, setSmsVerificationModalContentFlag] = useState(false)
    const [state, setState] = useState({

        passwordResetCode: "",
        password: "",
        retypePassword: "",

        usernameError: "",
        passwordResetCodeError: "",
        passwordError: "",
        retypePasswordError: "",

        hideShowChangePasswordPanel: false,
        passwordLock: false,
        rePasswordLock: false,
        passType: "password",
        reTypePassType: "password"
    })

    const { loaderStateTrue, loaderStateFalse, history, logOutApp } = props;

    //onchange event in forget password popup inputs
    const handleChange = (e) => {
        if (e.target.name == "username") {
            if (e.target.value != "") {
                setusername(e.target.value)
                setState(prevState => ({
                    ...prevState,
                    usernameError: ""
                }));
            } else {
                setusername("")
                setState(prevState => ({
                    ...prevState,
                    usernameError: ""
                }));
            }
            setusername(e.target.value)
        }

        //change password
        if (e.target.name == "password") {
            if (e.target.value == "") {
                setState(prev => ({
                    ...prev,
                    passwordError: `${props.t("passwordError")}`
                }))
            } else {
                setState(prev => ({
                    ...prev,
                    passwordError: ""
                }))
            }
        }
        if (e.target.name == "retypePassword") {
            if (e.target.value == "") {
                setState(prev => ({
                    ...prev,
                    retypePasswordError: `${props.t("retypepasswordError")}`
                }))
            } else {
                setState(prev => ({
                    ...prev,
                    retypePasswordError: ""
                }))
            }
        }
        if (e.target.name == "passwordResetCode") {
            if (e.target.value == "") {
                setState(prev => ({
                    ...prev,
                    passwordResetCodeError: `${props.t("enterverificationCode")}`
                }))
            } else {
                setState(prev => ({
                    ...prev,
                    passwordResetCodeError: ""
                }))
            }
        }

        if (e.target.name != "username") {
            setState(prev => ({
                ...prev,
                [e.target.name]: e.target.value
            }))
        }
    }

    //forgot password button click fn
    const forgotPassword = async () => {
        //email validation check
        if (ValidateUtility.validate_email(username)) {
            try {
                //dataset create
                let data = {}
                if (username != "") {
                    data['username'] = username;
                }
                if (username == "") {
                    data['username'] = phone_number;
                }

                data['application_platform'] = 'customer';
                loaderStateTrue();
                LoginController.forgotPassword(data).then((response) => {
                    loaderStateFalse();
                    if (response.success) {
                        if (response.message == "Username and a temporary password have been sent to your email. please log in using the credentials and change your password.") {
                            // Get saved redirect info if available
                            // const redirectInfo = getRedirectInfo();
                            // if (redirectInfo) {
                            //     // Create redirect URL preserving parameters
                            //     const redirectUrl = createRedirectUrl('/login', redirectInfo);
                            //     props.history.push(redirectUrl);
                            // } else {
                            // Fallback to normal redirect
                            props.history.push(`/${localStorage.getItem('i18nextLng')}/login`);
                            // }
                        } else {
                            setState(prev => ({
                                ...prev,
                                hideShowChangePasswordPanel: true
                            }))
                        }
                        Utility.toastNotifications(response.message, "Success", "success");
                    } else {
                        Utility.toastNotifications(response.message, "Error", "error");
                    }
                }).catch((error) => {
                    loaderStateFalse();
                    if (error?.response?.data?.message == "Your account hasn't been verified yet. A verification code has already been sent to your email. Please use it to verify your account before attempting to reset your password.") {
                        setSmsVerficationPopupStatus('user_unconfirmed')
                        smsVerificationFn();
                    }
                });

            } catch (error) {
                if (error.code == "UserNotFoundException") {
                    Utility.toastNotifications("User not found", "Error", "error")
                } else {
                    Utility.toastNotifications(error.message, "Error", "error")
                }
            }
        } else {
            setState(prev => ({
                ...prev,
                usernameError: props.t('validEmail')
            }))
        }

    }

    //change password fn
    const requestForNewPassword = async () => {
        const { passwordResetCode, password } = state;
        const { loaderStateFalse, loaderStateTrue } = props;
        if (validationForPasswordChange()) {
            try {
                let data = {}
                if (username != "") {
                    data['username'] = username;
                }
                data['password'] = password;
                data['confirmation_code'] = passwordResetCode;
                loaderStateTrue();
                LoginController.changePassword(data).then(async (response) => {
                    loaderStateFalse();
                    if (response.success) {
                        Utility.toastNotifications(response.message, "Success", "success");

                        // // Get saved redirect info if available
                        // const redirectInfo = await getRedirectInfo();
                        // // Clear the redirect info since we're going to use it
                        // clearRedirectInfo();
                        // console.log("redirectInfo", redirectInfo);
                        // if (redirectInfo) {
                        //     // Create redirect URL preserving parameters
                        //     const redirectUrl = await createRedirectUrl('/login', redirectInfo);
                        //     console.log("redirectUrl", redirectUrl);
                        //     history.push(redirectUrl);
                        // } else {
                        // console.log("No redirect info found");
                        // Fallback to home page
                        history.push(`/${localStorage.getItem('i18nextLng')}/login`);
                        // }
                    } else {
                        Utility.toastNotifications(response.message, "Error", "error");
                    }

                }).catch((error) => {
                    loaderStateFalse();
                });

            } catch (error) {
                if (error.code == "UserNotFoundException") {
                    Utility.toastNotifications("User not found", "Error", "error")
                } else {
                    Utility.toastNotifications(error.message, "Error", "error")
                }
            }
        }

    }

    const validationForEmail = () => {
        let valid = true;
        let emailValidate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(username);
        if (emailValidate || phone_number != "") {
            setState(prev => ({
                ...prev,
                usernameError: ""
            }))
        } else {
            valid = false;
            setState(prev => ({
                ...prev,
                usernameError: `${props.t('emailError')}`
            }))
        }

        return valid;
    }

    //change password valid fn
    const validationForPasswordChange = () => {
        let valid = true;
        const { passwordResetCode, password, retypePassword } = state;
        if (password == "") {
            valid = false;
            setState(prev => ({
                ...prev,
                passwordError: `${props.t('passwordError')}`
            }))
        } else {
            setState(prev => ({
                ...prev,
                passwordError: ""
            }))
        }
        if (retypePassword == "") {
            valid = false;
            setState(prev => ({
                ...prev,
                retypePasswordError: `${props.t('retypepasswordError')}`
            }))
        } else {
            setState(prev => ({
                ...prev,
                retypePasswordError: ""
            }))
        }

        if ((password != "" && retypePassword != "") && password != retypePassword) {
            valid = false;
            setState(prev => ({
                ...prev,
                retypePasswordError: `${props.t('passwordnotmatch')}`,
                passwordError: `${props.t('passwordnotmatch')}`
            }))
        }
        if (passwordResetCode == "") {
            valid = false;
            setState(prev => ({
                ...prev,
                passwordResetCodeError: `${props.t('enterverificationCode')}`
            }))
        } else {
            setState(prev => ({
                ...prev,
                passwordResetCodeError: ""
            }))
        }
        return valid;
    }
    const { hideShowChangePasswordPanel } = state;

    //redirect to login page
    const back_to_login = () => {
        // Get saved redirect info if available
        // const redirectInfo = getRedirectInfo();

        // if (redirectInfo) {
        //     // Create redirect URL preserving parameters
        //     const redirectUrl = createRedirectUrl('/login', redirectInfo);
        //     props.history.push(redirectUrl);
        // } else {
        // Use the current language or fallback to 'en'
        const language = localStorage.getItem('i18nextLng') || 'en';
        props.history.push(`/${language}/login`);
        // }
    }

    const lanOnSelect = (lng) => {
        let confirmation = false;
        confirmation = window.confirm(`${props.t('areYouSureYouWantToReload')}`);
        if (confirmation) {
            i18n.changeLanguage(lng);
            let splitUrl = props.match.url.split('/');
            props.history.push(`/${lng}/${splitUrl[2]}`);
            window.location.reload();
        }

    }

    //pass eye button hide show fn
    const hideShowEyeButton = (callFrom, type) => {
        if (type == "text") {
            if (callFrom == "pass") {
                setState(prev => ({
                    ...prev,
                    passwordLock: true,
                    passType: "text"
                }))
            } else {
                setState(prev => ({
                    ...prev,
                    rePasswordLock: true,
                    reTypePassType: "text"
                }))
            }

        } else {
            if (callFrom == "pass") {
                setState(prev => ({
                    ...prev,
                    passwordLock: false,
                    passType: "password"
                }))
            } else {
                setState(prev => ({
                    ...prev,
                    rePasswordLock: false,
                    reTypePassType: "password"
                }))
            }
        }
    }


    //initially redirection
    useEffect(() => {
        if (props.userCredentials.hasOwnProperty('user_details') && props.userCredentials.user_details && Object.keys(props.userCredentials.user_details).length > 0) {
            props.history.push(`/${localStorage.getItem('i18nextLng')}/home`);
        }
    }, []);

    //initially email coming from url then it will set forget password email field
    useEffect(() => {
        if (ValidateUtility.validate_email(type)) {
            setusername(type);
        }
    }, [])

    // mfa verification fn
    const smsVerificationFn = () => {
        setSmsVerificationModalContentFlag(true)
    }

    // mfa modal closing fn
    const closesmsVerificationFn = () => {
        setSmsVerificationModalContentFlag(false)
        setSmsVerficationPopupStatus("")
    }

    const handleSubmitOtpVerfication = (otp, mfaType) => {
        const { loaderStateTrue, loaderStateFalse } = props;
        // user is not confirmed his account 
        if (smsVerficationPopupStatus === 'user_unconfirmed') {
            let data = {
                "confirmation_code": otp.join(''),
                "email": username,
                'isReset': true
            }
            loaderStateTrue();
            LoginController.verifyOtp(data).then((response) => {
                if (response.success) {
                    closesmsVerificationFn();
                    forgotPassword();
                    Utility.toastNotifications(response.message, 'Success', 'success');
                } else {
                    Utility.toastNotifications(response.message, 'Error', 'error');
                }
                loaderStateFalse();
            }).catch((error) => {
                loaderStateFalse();
            });
        }
    }


    return (

        <div className="loginBackground">

            <div className='container'>
                <div className='innLoginPage forgotpassword-passhints'>
                    <div className='row'>
                        <div className={hideShowChangePasswordPanel ? "col-sm-4 d-none d-lg-block d-md-block" : "col-sm-6 d-none d-lg-block d-md-block"}>
                            <div className='leftInnLoginPage'>
                                <img src={require('../../../Utility/Public/images/resetIcon.png')} className="loginIcon" />
                            </div>
                        </div>
                        <div className={hideShowChangePasswordPanel ? "col-lg-5 col-md-5 col-sm-12" : "col-lg-6 col-md-6 col-sm-12"}>
                            <div className='rightInnLoginPage'>
                                <div className="left_section login_box_inner white_background forgotpass">
                                    <div className="logo-box-inner">
                                        <div className="titleposition">
                                            <h2 className="titleone">MettaStay</h2>
                                            <h3 className="titletwo">Online property booking management</h3>
                                        </div>
                                    </div>
                                    <div className="itemsContainer login_left_inner">

                                        <div className="forgotFormDiv forgotDivInner">
                                            {hideShowChangePasswordPanel == false ?
                                                <div>
                                                    <CustomInput
                                                        parentClassName="loginFormInnerDiv input_field_small_size emaillabel"
                                                        onChange={handleChange}
                                                        name="username"
                                                        value={username != "" ? username : phone_number}
                                                        labelName="Email"
                                                        errorLabel={state.usernameError}
                                                        labelPresent={false}
                                                        requiredStar={false}
                                                        placeholder="Email"
                                                    />
                                                    <div className="forgor_btn_inner_div logbtndiv">
                                                        <button className="login-btn btn btn-primary" onClick={forgotPassword}>{props.t('resetPasswordButton')}</button>
                                                    </div>
                                                    <div className="back_inner_div">
                                                        <p className="backtolog" onClick={back_to_login}><span>{props.t('resetPasswordbackToLogin')}</span></p>
                                                    </div>
                                                </div> :
                                                <div>
                                                    <CustomInput
                                                        parentClassName="loginFormInnerDiv input_field_small_size email_disable_field"
                                                        name="username"
                                                        value={state.username}
                                                        readOnly={true}
                                                        placeholder={props.t('emailIdPlaceHolder')}
                                                    />
                                                    <CustomInput
                                                        parentClassName="loginFormInnerDiv input_field_small_size"
                                                        onChange={handleChange}
                                                        name="passwordResetCode"
                                                        value={state.passwordResetCode}
                                                        placeholder={props.t('Verificationcode')}
                                                        errorLabel={state.passwordResetCodeError}
                                                    />
                                                    <div className='positionRelative'>
                                                        <CustomInput
                                                            parentClassName="loginFormInnerDiv input_field_small_size"
                                                            onChange={handleChange}
                                                            name="password"
                                                            type={state.passType == "text" ? "text" : "password"}
                                                            value={state.password}
                                                            errorLabel={state.passwordError}
                                                            placeholder={props.t('NewpasswordPlaceHolder')}
                                                        />
                                                        {!state.passwordLock ?
                                                            <span className="passwordEyeIcon" onClick={() => { hideShowEyeButton("pass", "text") }}>
                                                                <i className="fa fa-eye-slash" aria-hidden="true"></i>
                                                            </span>

                                                            :
                                                            <span className="passwordEyeIcon" onClick={() => { hideShowEyeButton("pass", "password") }}>
                                                                <i className="fa fa-eye" aria-hidden="true"></i>
                                                            </span>

                                                        }
                                                    </div>
                                                    <div className='positionRelative'>
                                                        <CustomInput
                                                            parentClassName="loginFormInnerDiv input_field_small_size"
                                                            onChange={handleChange}
                                                            name="retypePassword"
                                                            type={state.reTypePassType == "text" ? "text" : "password"}
                                                            value={state.retypePassword}
                                                            placeholder={props.t('RetypenewpasswordPlaceHolder')}
                                                            errorLabel={state.retypePasswordError}
                                                        />
                                                        {!state.rePasswordLock ?
                                                            <span className="passwordEyeIcon" onClick={() => { hideShowEyeButton("retypepass", "text") }}>
                                                                <i className="fa fa-eye-slash" aria-hidden="true"></i>
                                                            </span>

                                                            :
                                                            <span className="passwordEyeIcon" onClick={() => { hideShowEyeButton("retypepass", "password") }}>
                                                                <i className="fa fa-eye" aria-hidden="true"></i>
                                                            </span>

                                                        }
                                                    </div>
                                                    <div className="forgor_btnBoxes forgotpassmodify">
                                                        <div className="forgor_btn_inner_div bottom15">
                                                            <button className="login-btn btn btn-primary" onClick={requestForNewPassword}>{props.t('ChangePasswordButton')}</button>
                                                        </div>

                                                        <p className="resendverificationbtn" onClick={forgotPassword}>{props.t('ResendverificationcodeButton')}</p>

                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {hideShowChangePasswordPanel ?
                                        <div className='password-rules-box forgot-rule-box'>
                                            <div className='pass-right-box'>
                                                <h5>Password Hints:</h5>
                                                <ul className='password-inner-box'>
                                                    <li><span>Minimum length</span>, which must be at least 8 characters</li>
                                                    <li><span>Contains at least 1 number</span></li>
                                                    <li><span>Contains at least 1 special character</span> {"from this set: ^ $ * . [ ] { } ( ) ? - ! @ # % & / \\ , > < ' : ; | _ ~ ` + = "} <br /><span>The non-leading, non-trailing space character is also treated as a special character.</span></li>
                                                    <li><span>Contains at least 1 uppercase letter</span></li>
                                                    <li><span>Contains at least 1 lowercase letter</span></li>
                                                </ul>
                                            </div>
                                        </div> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalGlobal
                show={smsVerificationModalContentFlag}
                onHide={closesmsVerificationFn}
                title=""
                className="modalcustomize mondimension smsVerificationModalContent"
                footer={false}
                closeButton={true}
                saveButtonLabel="Confirm"
                saveButtonClassName="btn btn-primary savebtn"
                cancelShow={true}
                body={
                    <>

                        <SmsVerification
                            formData={{ 'email': username }}
                            callFrom={smsVerficationPopupStatus == 'user_unconfirmed' ? 'email' : 'SMS_MFA'}
                            handleSubmitOtpVerfication={handleSubmitOtpVerfication}
                        />

                    </>
                }
            />
        </div>
    )

}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
    };
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setToken, logOutApp })(withNamespaces()(ForgotPassword));